export const COMPONENTS = [
  {
    value: "INSTRUCTIONAL_SYLLABUS",
    label: "Instructional & Syllabus Coverage",
  },
  { value: "DISCIPLINE", label: "Discipline" },
  { value: "CREATIVITY", label: "Creativity & Co-curricular" },
];

export const STATUSES = [
  { value: "in_progress", label: "In Progress" },
  { value: "deputy_head_teacher_review", label: "Deputy Head Teacher Review" },
  { value: "head_teacher_review", label: "Head Teacher Review" },
  { value: "approved", label: "Approved" },
];

export const listFrom = (data) =>
  Array.isArray(data) ? data : data?.results || [];
export const scoreText = (value) =>
  value === null || value === undefined || value === ""
    ? "Not scored"
    : Number(value).toFixed(2);

export function errorText(data) {
  if (data instanceof Error)
    return data.message || "Request failed. Please try again.";
  if (typeof data === "string") return data;
  if (Array.isArray(data)) return data.map(errorText).join("; ");
  if (data && typeof data === "object") {
    const message = Object.entries(data)
      .map(
        ([key, value]) =>
          `${key === "detail" || key === "non_field_errors" ? "" : `${key}: `}${errorText(value)}`,
      )
      .join("; ");
    return message || "Request failed. Please try again.";
  }
  return "Request failed. Please try again.";
}

export function appraisalRoles(roleNames, user = {}) {
  const names = (Array.isArray(roleNames) ? roleNames : []).map((role) =>
    String(typeof role === "string" ? role : role?.name || "").toLowerCase(),
  );
  const superuser = user.is_superuser === true || user.isSuperuser === true;
  const has = (keyword, alias) =>
    names.some(
      (name) =>
        name.includes(keyword) ||
        (alias &&
          (name.trim() === alias ||
            name.includes(`(${alias})`) ||
            name.startsWith(`${alias} (`))),
    );
  const hod = superuser || has("head of department", "hod");
  const deputy = superuser || has("deputy head teacher", "dht");
  // Roles are additive: holding a deputy role must not cancel a head-teacher role.
  const head =
    superuser ||
    names.some(
      (name) =>
        !name.includes("deputy") &&
        (name.includes("head teacher") || name.includes("(ht)")),
    ) ||
    has("principal");
  return {
    superuser,
    admin: superuser || has("system administrator"),
    criteriaManager: has("system administrator"),
    fiveRAssessor: has("head of department", "hod"),
    hod,
    deputy,
    head,
    flag:
      superuser ||
      hod ||
      deputy ||
      names.some(
        (name) => !name.includes("deputy") && name.includes("head teacher"),
      ),
  };
}

export function allowedActions(record, roles, cycleLocked = false) {
  const actions = [];
  if (
    record.status === "in_progress" &&
    roles.fiveRAssessor &&
    record.fiveRComplete === true &&
    record.fiveR?.isLocked !== true &&
    !cycleLocked
  )
    actions.push("Approved");
  if (record.status === "deputy_head_teacher_review" && roles.deputy)
    actions.push("Consolidated", "Returned", "Reopened");
  if (record.status === "head_teacher_review" && roles.head)
    actions.push("final-approve", "Returned", "Reopened");
  if (record.status === "approved" && roles.head) actions.push("Reopened");
  if (roles.flag) actions.push("flag", "unflag");
  return actions;
}

export const ACTION_LABELS = {
  Approved: "Submit for review",
  Consolidated: "Consolidate",
  Returned: "Return",
  Reopened: "Reopen",
  "final-approve": "Final approve",
  flag: "Flag",
  unflag: "Clear flag",
};
